import { render, staticRenderFns } from "./VTour.vue?vue&type=template&id=59e264be"
import script from "./VTour.vue?vue&type=script&lang=js"
export * from "./VTour.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./VTour.vue?vue&type=style&index=0&id=59e264be&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports